import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12.511 17.74c.126-2.769 2.463-5.105 5.232-5.23a5.5 5.5 0 0 1 1.867.23c.19.06.39-.07.39-.28V9.05a.3.3 0 0 0-.3-.3H2.3a.3.3 0 0 0-.3.3V17q0 3 3 3h7.46c.21 0 .34-.2.28-.39a5.5 5.5 0 0 1-.229-1.87M7.021 17a1.005 1.005 0 0 1-1.005-1c0-.552.443-1 .995-1h.01a1 1 0 1 1 0 2m0-4a1.005 1.005 0 0 1-1.005-1c0-.552.443-1 .995-1h.01a1 1 0 1 1 0 2m4 0a1.005 1.005 0 0 1-1.005-1c0-.552.443-1 .995-1h.01a1 1 0 1 1 0 2m-9.02-6.05V6.5q0-3 3-3h1.25V2c0-.41.34-.75.75-.75s.75.34.75.75v1.5h6.5V2c0-.41.34-.75.75-.75s.75.34.75.75v1.5h1.25q3 0 3 3v.45a.3.3 0 0 1-.3.3H2.3a.3.3 0 0 1-.3-.3m16 7.05a4 4 0 1 0 0 8 4 4 0 0 0 0-8m1.425 5.424a.5.5 0 0 1-.708 0l-1.071-1.071a.5.5 0 0 1-.146-.354v-1.5a.5.5 0 0 1 1 0v1.293l.925.924a.5.5 0 0 1 0 .708"
    }, null, -1)
  ])))
}
export default { render: render }